/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Why the gateway is not served. Set only when not available.
 */
export const OrganizationGatewayUnavailableReason = {
  NoOrganizationIssuer: "no_organization_issuer",
  MultipleOrganizationIssuers: "multiple_organization_issuers",
  CustomDomainOnly: "custom_domain_only",
  OrganizationDisabled: "organization_disabled",
  TurnedOff: "turned_off",
} as const;
/**
 * Why the gateway is not served. Set only when not available.
 */
export type OrganizationGatewayUnavailableReason = OpenEnum<
  typeof OrganizationGatewayUnavailableReason
>;

/**
 * The active organization's gateway, or why it is not served.
 */
export type OrganizationGateway = {
  /**
   * Whether the organization is served a gateway.
   */
  available: boolean;
  /**
   * Why the gateway is not served. Set only when not available.
   */
  unavailableReason?: OrganizationGatewayUnavailableReason | undefined;
  /**
   * The gateway's MCP URL. Set only when available.
   */
  url?: string | undefined;
};

/** @internal */
export const OrganizationGatewayUnavailableReason$inboundSchema: z.ZodMiniType<
  OrganizationGatewayUnavailableReason,
  unknown
> = openEnums.inboundSchema(OrganizationGatewayUnavailableReason);

/** @internal */
export const OrganizationGateway$inboundSchema: z.ZodMiniType<
  OrganizationGateway,
  unknown
> = z.pipe(
  z.object({
    available: z.boolean(),
    unavailable_reason: z.optional(
      OrganizationGatewayUnavailableReason$inboundSchema,
    ),
    url: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "unavailable_reason": "unavailableReason",
    });
  }),
);

export function organizationGatewayFromJSON(
  jsonString: string,
): SafeParseResult<OrganizationGateway, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OrganizationGateway$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OrganizationGateway' from JSON`,
  );
}
